/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Case_Contact_Deactivate_ErrorInputs */

const en_case_contact_deactivate_error = /** @type {(inputs: Case_Contact_Deactivate_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to deactivate contact: ${i?.message}`)
};

const pt_br2_case_contact_deactivate_error = /** @type {(inputs: Case_Contact_Deactivate_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao desativar contato: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Failed to deactivate contact: {message}" |
*
* @param {Case_Contact_Deactivate_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_contact_deactivate_error = /** @type {((inputs: Case_Contact_Deactivate_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Contact_Deactivate_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_contact_deactivate_error(inputs)
	return pt_br2_case_contact_deactivate_error(inputs)
});